"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImUSDOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ImUSDOracleFactory = /** @class */ (function (_super) {
    __extends(ImUSDOracleFactory, _super);
    function ImUSDOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ImUSDOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ImUSDOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ImUSDOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ImUSDOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ImUSDOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ImUSDOracleFactory;
}(contracts_1.ContractFactory));
exports.ImUSDOracleFactory = ImUSDOracleFactory;
var _abi = [
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "imUSDAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mUSDCrvPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
